export default __webpack_public_path__ + "static/media/graph2.a833f73e.png";